import $ from 'jquery'

_require [
  'search/filter_location',
  'swiper',
  'bootstrap/popover',
], ->
  $(document).ready ->
    $('.dropdown-toggle').hover (->
      target_dropdown = $(this).attr('data-target')
      $(target_dropdown).addClass 'open'
    ), ->
      target_dropdown = $(this).attr('data-target')
      $(target_dropdown).removeClass 'open'

    updateCollapse = ->
      _require ['bootstrap/collapse'], ->
        if $(window).width() < 767
          $('.collapse').collapse('hide')
        else
          $('.collapse').collapse('show')
        return

    updateCollapse()

    window.addEventListener('resize', updateCollapse)

    _require ['readmore'], ->
      numLines = 3
      $('.js-reply-text > p').readmore
        moreLink: '<a href="#">VER MAIS</a>'
        lessLink: '<a href="#">VER MENOS</a>'
        # 4 lines
        collapsedHeight: numLines * (parseInt($('.js-reply-text > p').css('line-height')) || 24)

    update_evaluation_cards = (data) ->
      $('#answers-container').empty()
      $('#answers-container').append(data["html"])
      updateCollapse()
      update_pagintation()
      new QB.RatingPopover()

    update_filter_numbers = (data) ->
      nps_labels = $('#nps-filter-column .filter-number')
      nps_labels.each (index, el) ->
        label_number =  data["filter_label_numbers"]["nps_count"][$(el).data("value")]
        label_number = if typeof label_number == 'undefined' then 0 else label_number
        str = '(' + label_number + ')'
        $(el).html(str)
      level_labels = $('#level-filter-column .filter-number')
      level_labels.each (index, el) ->
        label_number =  data["filter_label_numbers"]["level_count"][$(el).data("value")]
        label_number = if typeof label_number == 'undefined' then 0 else label_number
        str = '(' + label_number + ')'
        $(el).html(str)
      kind_labels = $('#kind-filter-column .filter-number')
      kind_labels.each (index, el) ->
        label_number =  data["filter_label_numbers"]["kind_count"][$(el).data("value")]
        label_number = if typeof label_number == 'undefined' then 0 else label_number
        str = '(' + label_number + ')'
        $(el).html(str)
      $('#filter-current-page').html(data['page_info']['current_page'])
      total_pages = Math.ceil(data['page_info']['total_count']/data['page_info']['per_page'])
      $('#filter-total-page').html(total_pages)
      start_index = data['page_info']['per_page']*(data['page_info']['current_page']-1)+1
      end_index_a = data['page_info']['per_page']*data['page_info']['current_page']
      end_index_b = data['page_info']['total_count']
      end_index = if end_index_a < end_index_b then end_index_a else end_index_b
      $('#filter-current-results').html(start_index+' - '+end_index)
      $('#filter-total-results').html(data['page_info']['total_count'])

    reset_page = ->
      $('#pagination-input').val('1')

    send_filter_form = ->
      url = $('#facets').attr("data-action")
      params = $('#facets').serialize()
      $('#js-cog').removeClass 'hidden'
      $('body').addClass 'freeze-scroll'
      $.ajax
        url: url+'?'+params
        success: (data) ->
          update_filter_numbers data
          update_evaluation_cards data
          $('#js-cog').addClass 'hidden'
          $('body').removeClass 'freeze-scroll'
          $("html, body").animate({ scrollTop: $('.evaluation-filter').offset().top }, 400)
          return
        error: ->
          $('#js-cog').addClass 'hidden'
          $('body').removeClass 'freeze-scroll'
          console.log "request error"
          return

    update_pagintation = ->
      $('.qb-pagination a').on "click", (e) ->
        e.preventDefault()
        next_page = $(e.currentTarget).data('page')
        $('#pagination-input').val(next_page)
        send_filter_form()
        _require ['metrics'], ->
          trackable.eventTracker.track Metrics.Events.ViewedMoreReviews

    if $('.moderation').length == 0
      update_pagintation()

    track_apply_filter = ->
      _require ['metrics',], ->
        raw_params = $('#facets').serializeArray()
        filters = []
        i = 0
        while i < raw_params.length
          if raw_params[i].value and raw_params[i].name != 'page'
            filters.push raw_params[i].name.replace '[]', ''
          i++
        trackable.eventTracker.track Metrics.Events.FilteredReviews, {usedFilters: filters}

    $('#facets input').change (e) ->
      if $(e.currentTarget).attr('id') == 'pagination-input'
        send_filter_form()
      else
        reset_page()
        if $(window).width() >= 768
          send_filter_form()
          track_apply_filter()

    $('#facets select').change (e) ->
      reset_page()
      if $(window).width() >= 768
        send_filter_form()
        track_apply_filter()

    $('.js-apply-filters-xs').on 'click', (e) ->
      reset_page()
      send_filter_form()
      track_apply_filter()

    $('.filter-element').on 'click', (e) ->
      $(this).find('input').click()

    new Search.FilterLocation()

    if QB.isMobile
      limit_filter_scroll = $('#filter-button-container').offset().top - 16
      $(window).on 'scroll', ->
        currentPosition = $(window).scrollTop()
        if currentPosition > limit_filter_scroll
          $('#filter-button-container').addClass 'fixed-top'
        else
          $('#filter-button-container').removeClass 'fixed-top'

    $('#course').select2V3
      placeholder: "Digite ou escolha o curso"
      allowClear: true
      containerCssClass: 'qb-s2v3'
      dropdownCssClass: 'qb-s2v3'
    $('#campus').select2V3
      placeholder: "Digite ou escolha o campus"
      allowClear: true
      containerCssClass: 'qb-s2v3'
      dropdownCssClass: 'qb-s2v3'

    _require ['metrics'], ->
      trackable.eventTracker.track Metrics.Events.ViewedReviewsPage

_require ['canonical_selector'], ->
  canonicalSelect = new QB.CanonicalSelector
  canonicalSelect.init('#interest_course_in_modal')
  canonicalSelect.init('#interest_course_in_header', 'courses-canonical-id')
